import React from 'react';

import { ComponentProps } from '../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../utils/styles';
import './strip-label.scss';

export interface IStripLabel extends ComponentProps {
  children?: JSX.Element;
  label?: string;
  cssModifier?: string;
  href?: string;
  intcmp?: string;
  onClick?: () => void;
}

const classNames = (cssModifier?: string): IClassNames =>
  makeClassNames({
    StripLabel: ['strip-label', 'j-strip-label', cssModifier && `strip-label--${cssModifier}`],
    StripLabelIcon: 'strip-label__icon',
    StripLabelText: 'strip-label__text',
  });

const StripLabel: React.FC<IStripLabel> = ({ children, label, cssModifier, href, onClick }) => {
  const cn = classNames(cssModifier);
  const BtnTagElement = href ? 'a' : 'p';

  return (
    <div onClick={onClick} className={cn.StripLabel}>
      <BtnTagElement href={href} className={cn.StripLabelText} onClick={onClick}>
        {children && <span className={cn.StripLabelIcon}>{children}</span>}
        {label}
      </BtnTagElement>
    </div>
  );
};

export default StripLabel;
